import * as types from "../../actionType";
import Cookies from "js-cookie";
import { client } from "../../AxiosInterceptor";
import { toast } from "../../../UIComponents/Toast";

const archivedBrandsListLoading = () => ({
  type: types.ARCHIVED_BRANDS_LIST_LOADING,
});
const archivedBrandsListSuccess = (data) => ({
  type: types.ARCHIVED_BRANDS_LIST_SUCCESS,
  payload: data,
});
const archivedBrandsListFail = (error) => ({
  type: types.ARCHIVED_BRANDS_LIST_FAIL,
  payload: error,
});

const archivedBrandStylesLoading = () => ({
  type: types.ARCHIVED_BRAND_STYLES_LOADING,
});
const archivedBrandStylesSuccess = (data) => ({
  type: types.ARCHIVED_BRAND_STYLES_SUCCESS,
  payload: data,
});
const archivedBrandStylesFail = (error) => ({
  type: types.ARCHIVED_BRAND_STYLES_FAIL,
  payload: error,
});

export const getArchivedBrandStyles = (
  brand,
  season = "",
  search = "",
  page = 1,
  pageSize = 20
) => {
  let secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const archivedBrandStylesConfig = {
      method: "GET",
      url: `archived/brands/styles?brand=${encodeURIComponent(brand)}&season=${encodeURIComponent(season)}&search=${encodeURIComponent(search)}&page=${page}&page_size=${pageSize}`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(archivedBrandStylesLoading());
    client(archivedBrandStylesConfig)
      .then((resp) => {
        dispatch(archivedBrandStylesSuccess(resp.data));
      })
      .catch((error) => {
        dispatch(archivedBrandStylesFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        }
      });
  };
};

export const getArchivedBrandsList =(season = "", search = "") => {
  let secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const archivedBrandsConfig = {
      method: "GET",
      url: `archived/brands?season=${encodeURIComponent(season)}&search=${encodeURIComponent(search)}`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(archivedBrandsListLoading());
    client(archivedBrandsConfig)
      .then((resp) => {
        dispatch(archivedBrandsListSuccess(resp.data));
      })
      .catch((error) => {
        dispatch(archivedBrandsListFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        }
      });
  };
};
